import { render, staticRenderFns } from "./DialogDownload.vue?vue&type=template&id=dddd8ca8&scoped=true&"
import script from "./DialogDownload.vue?vue&type=script&lang=js&"
export * from "./DialogDownload.vue?vue&type=script&lang=js&"
import style0 from "./DialogDownload.vue?vue&type=style&index=0&id=dddd8ca8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddd8ca8",
  null
  
)

export default component.exports